import '../CSSFiles/NavBar.css'
import phone_icon from "../Images/phone_icon.png"
import location_icon from "../Images/location_icon.png"
import auto_logo from "../Images/main_logo.png"

export const NavBar = (props) => {



    const ScrollToServices = () => {
        document.getElementById('services').scrollIntoView({ behavior: 'smooth'});
      }
    
      const ScrollToContactInformation = () => {
        document.getElementById('contact-info').scrollIntoView({ behavior: 'smooth'});
      }
      


    return <div className="nav-bar">
        <div className='top-nav-bar'>
            <h3> Nova Auto Repair</h3>
            <div className="top-nav-info">
                <img src={phone_icon} alt="icon" />
                <a  href="tel:+15716914779"> (571)-691-4779</a>
            </div>
            <div className="top-nav-info">
                <img src={location_icon} alt="icon" />
                <a target="_blank" href="https://g.co/kgs/ZpfA1p3"> 9106 Euclid Ave</a>
            </div>
        </div>
        <div className='bottom-nav-bar'>
            <div className="nav-bottom-left">
                <img src={auto_logo} alt="Nova auto repairs logo"/>
            </div>
            <div className="nav-bottom-right">
                <a onClick={ScrollToServices}> Services </a>
                <a onClick={ScrollToContactInformation}> Contact Us </a>
            </div>
        </div>
    </div>
}